import { render, staticRenderFns } from "./MsgPersistent.vue?vue&type=template&id=a070b536&"
import script from "./MsgPersistent.vue?vue&type=script&lang=js&"
export * from "./MsgPersistent.vue?vue&type=script&lang=js&"
import style0 from "./MsgPersistent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports